var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen
    ? _c(
        "dialog",
        {
          ref: "deleteModal",
          staticClass: "delete-modal",
          attrs: { id: "deleteModal" },
          on: { close: _vm.closeModal },
        },
        [
          _c("button", {
            staticClass: "close-button",
            attrs: { "aria-label": "Close modal" },
            on: { click: _vm.closeModal },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h4", { staticClass: "delete-modal__heading" }, [
              _vm._v("\n      Delete this item?\n    "),
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.closeModal } },
              [_vm._v("\n      Cancel\n    ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button button--primary",
                on: { click: _vm.deleteItem },
              },
              [_vm._v("\n      Delete\n    ")]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }